import Vue from 'vue'
import VueRouter from 'vue-router'
import login_page from '../views/login_page'
import home_page from '../views/home_page'
import welcome_page from '../views/welcome_page'
import all_DC_info_small from '../views/all_DC_info_small'
import DC_GR_1F from '../views/DC_GR_1F'
import DC_ZH_3F from '../views/DC_ZH_3F'
import DC_ZH_5F from '../views/DC_ZH_5F'
import DC_ZH_1F from '../views/DC_ZH_1F'
import DC_HQ_5 from '../views/DC_HQ_5F'
import DC_ZY_3 from '../views/DC_ZY_3'
import Network_all from '../views/Network_all'
import Server_Stor from '../views/Server_Stor'
import DC_env_all from '../views/DC_env_all'
import APP1 from '../views/APP1'
import APP2 from '../views/APP2'
import APP3 from '../views/APP3'
// import infoServer from '../views/infoServer'
// import infoSwitch from '../views/infoSwitch'
// import infoFW from '../views/infoFW'
// import infoStorage from '../views/infoStorage'
// import infoUPS from '../views/infoUPS'
// import infoAirCondictioner from '../views/infoAirCondictioner'
// import reportEventDetail from '../views/reportEventDetail'
// import reportEventTimesAll from '../views/reportEventTimesAll'
// import zabbix_dashboard_1 from '../views/zabbix_dashboard_1'
// import software_detail from '../views/software_detail'

//避免路由报错的脚本
const originalPush = VueRouter.prototype.push

VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}


Vue.use(VueRouter)


const routes = [
  {
    path: '/',
    name: 'login_page',
    component: login_page
  },
  {
    path: '/home',
    name: 'home_page',
    component: home_page,
    redirect: "/welcome",
    children: [
      {
        path: '/welcome',
        name: 'welcome_page',
        component: welcome_page
      },
      {
        path: '/DC_GR_1F',
        name: 'DC_GR_1F',
        component: DC_GR_1F
      },
      {
        path: '/DC_ZH_3F',
        name: 'DC_ZH_3F',
        component: DC_ZH_3F
      },
      {
        path: '/DC_ZH_5F',
        name: 'DC_ZH_5F',
        component: DC_ZH_5F
      },
      {
        path: '/DC_ZH_1F',
        name: 'DC_ZH_1F',
        component: DC_ZH_1F
      },
      {
        path: '/DC_HQ_5F',
        name: 'DC_HQ_5',
        component: DC_HQ_5
      },
      {
        path: '/DC_ZY_3',
        name: 'DC_ZY_3',
        component: DC_ZY_3
      },
      {
        path: '/Network_all',
        name: 'Network_all',
        component: Network_all
      },
      {
        path: '/Server_Stor',
        name: 'Server_Stor',
        component: Server_Stor
      },
      {
        path: '/all_DC_info_small',
        name: 'all_DC_info_small',
        component: all_DC_info_small
      },
      {
        path: '/DC_env_all',
        name: 'DC_env_all',
        component: DC_env_all
      },
      {
        path: '/APP1',
        name: 'APP1',
        component: APP1
      },
      {
        path: '/APP2',
        name: 'APP2',
        component: APP2
      },
      {
        path: '/APP3',
        name: 'APP3',
        component: APP3
      },
    ]
  },
  // {
  //   path: '/ds_zabbix_dashboard_1',
  //   name: 'zabbix_dashboard_1',
  //   component: zabbix_dashboard_1
  // },

]

const router = new VueRouter({
  routes
})

// router.beforeEach((to, from, next) => {
//   if (to.path === '/') {
//     return next()
//   }
//   const logon_status = window.sessionStorage.getItem('logon')

//   // const logon_status = 1
//   if (logon_status == '1') {
//     return next()
//   }
//   alert("请先登录")
//   // this.$message({
//   //   type: "warning",
//   //   message: "请先登录",
//   // });
//   return next('/')
// }
// )

export default router
